
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/[item]",
      function () {
        return require("private-next-pages/items/[item].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/[item]"])
      });
    }
  